// 1 广告主。2 广告代理服务商 15 isv服务商
export const activeAccountType = {
  ader: 1,
  proxyAgency: 2,
  isvAgency: 15,
};

export const activeAccountTypeKey2Val = {
  1: '广告主',
  2: '广告代理服务商',
  15: 'ISV服务商',
};
